services.service('FacebookAuthProvider', [
    '$q', 'ExternalScriptLoader',

    function ($q, ExternalScriptLoader) {
        function FacebookAuthProvider(config) {
            var self = this;

            var VERISON = "v4.0"
            var FIELDS = 'name,email,picture,first_name,last_name';
            var loader = new ExternalScriptLoader();

            var opt = {scope: 'email,public_profile'}

            var id = config.id;
            self.ready = false;

            this.init = function () {
                function fbInit() {
                    return new $q(function (resolve, reject) {
                        FB.init({
                            appId: id,
                            autoLogAppEvents: true,
                            cookie: true,
                            xfbml: true,
                            version: VERISON
                        });
                        self.ready = true;
                        resolve()
                    })
                }

                return loader.load('//connect.facebook.net/en_US/sdk.js')
                    .then(fbInit)
            }


            this.isLoggedIn = function () {
                return getLoginStatus()
                    .then(function () {
                        return true
                    })
                    .catch(function (error) {
                        return false
                    })
            }

            this.signIn = function (opts) {
                function login() {
                    return $q(function (resolve, reject) {
                        FB.login(function (response) {
                            response.authResponse
                                ? resolve(response.authResponse)
                                : reject("Facebook login failed")
                        }, opt)
                    })
                }

                return login()
                    .then(function (response) {
                        return getUserDetails()
                            .then(function (user) {
                                user.token = response.accessToken;
                                return user;
                            })
                    })
            }

            this.signOut = function (revoke) {
                return $q(function (resolve, reject) {
                    FB.logout(resolve)
                })
            }

            this.getUser = function () {
                return $q
                    .all([getLoginStatus(), getUserDetails()])
                    .then(function (data) {
                        var response = data[0];
                        var user = data[1];
                        user.token = response["accessToken"];
                        return user;
                    })
            }

            function getLoginStatus() {
                return $q(function (resolve, reject) {
                    FB.getLoginStatus(function (response) {
                        if (response.status === 'connected') {
                            resolve(response.authResponse);
                        }
                        reject("User is not logged in")
                    })
                })
            }

            function getUserDetails() {
                return $q(function (resolve, reject) {
                    FB.api("/me?fields=" + FIELDS, function (fbUser) {
                        var user = {
                            provider: "facebook",
                            id: fbUser.id,
                            email: fbUser.email,
                            name: fbUser.name,
                            photoUrl: 'https://graph.facebook.com/' + fbUser.id + '/picture?type=normal',
                            firstName: fbUser.first_name,
                            lastName: fbUser.last_name,
                            facebook: fbUser
                        }

                        resolve(user);
                    })
                })
            }

        }

        return FacebookAuthProvider
    }
])
